module.exports = __webpack_public_path__ + "static/media/item04.f0780431.png";